import _ from 'lodash';
import {
    FAVOURITE_SUCCESS,
    FAVOURITE_FAILED
} from '../actions/types';

export default function(state = [], action) {
    switch (action.type) {
        case FAVOURITE_SUCCESS:
            return {
                ..._.mapKeys(action.payload.favourites, 'projectId')
            };
        case FAVOURITE_FAILED:
            return {
                ...state
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/favouritesReducer.js